import { FaChartArea, FaHome, FaQuestion } from "react-icons/fa";
import Home from "../pages/home";
import Statistics from "../pages/statistics";
import Questions from "../pages/questions";

export interface ICrudRoutes {
  path: string;
  component: React.ReactNode;
}

export interface ISubRoute {
  labelKey: string;
  icon?: JSX.Element;
  path: string;
  // permissions: string[]
  component: any;
  crudRoutes?: ICrudRoutes[];
  exact?: boolean;
}

export interface IRoute {
  labelKey: string;
  icon: JSX.Element;
  path: string;
  crudRoutes?: ICrudRoutes[];
  roles?: string[];
  hasSubMenus: boolean;
  subMenus?: ISubRoute[];
  component?: any;
  exact?: boolean;
}

export const routes: IRoute[] = [
  {
    labelKey: "الصفحة الرئيسية",
    icon: <FaHome />,
    path: "/",
    hasSubMenus: false,
    component: <Home />,
  },
  {
    labelKey: "الاحصائيات",
    icon: <FaChartArea />,
    path: "/statistics",
    hasSubMenus: false,
    component: <Statistics />,
  },

  {
    labelKey: "الأسئلة",
    icon: <FaQuestion />,
    path: "/reports",
    hasSubMenus: true,
    subMenus: [
      {
        path: "/client-summary-report",
        labelKey: "أسئلة",
        component: <Questions />,

        crudRoutes: [
          {
            path: "",
            component: <></>,
          },
        ],
      },
    ],
  },
];
